//文字コードはutf-8

export function getTypingDuration() {
    const el = document.querySelector('.jsKvText');
    if (!el) return 0;
    let count = 0;
    el.childNodes.forEach(node => {
        if (node.nodeName === 'BR') {
            count++;
        } else if (node.nodeType === Node.TEXT_NODE) {
            count += [...node.textContent].length;
        }
    });
    return count * 100;
}

/**
 * @returns {number} Total typing duration in ms
 */
export function initTypingAnimation() {
    const el = document.querySelector('.jsKvText');
    if (!el) return 0;

    // Extract text content, preserving line breaks from <br> tags
    const nodes = [...el.childNodes];
    const chars = [];
    nodes.forEach(node => {
        if (node.nodeName === 'BR') {
            chars.push('br');
        } else if (node.nodeType === Node.TEXT_NODE) {
            chars.push(...[...node.textContent]);
        }
    });

    const typingDuration = chars.length * 100;

    // Clear and start typing
    el.textContent = '';
    el.classList.add('is-typing');

    let i = 0;
    const type = () => {
        if (i < chars.length) {
            const char = chars[i];
            if (char === 'br') {
                el.appendChild(document.createElement('br'));
            } else {
                el.appendChild(document.createTextNode(char));
            }
            i++;
            setTimeout(type, 100);
        } else {
            // Fade in the link after 0.5s delay
            const link = document.querySelector('.topKv__link');
            if (link) {
                setTimeout(() => {
                    link.classList.add('is-visible');
                }, 500);
            }

            setTimeout(() => {
                el.classList.remove('is-typing');
                el.classList.add('is-typed');
            }, 1500);
        }
    };

    type();
    return typingDuration;
}

function extractChars(el) {
    const chars = [];
    el.childNodes.forEach(node => {
        if (node.nodeName === 'BR') {
            chars.push({ type: 'br' });
        } else if (node.nodeType === Node.TEXT_NODE) {
            [...node.textContent].forEach(char => {
                chars.push({ type: 'text', value: char });
            });
        } else if (node.nodeName === 'SPAN') {
            [...node.textContent].forEach(char => {
                chars.push({ type: 'span', value: char });
            });
        }
    });
    return chars;
}

function createCursor() {
    const cursor = document.createElement('span');
    cursor.className = 'jsTypingCursor';
    cursor.setAttribute('aria-hidden', 'true');
    return cursor;
}

function insertLineBreaks(el) {
    const range = document.createRange();
    const breaks = [];
    let lastTop = null;

    [...el.childNodes].forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
            const text = node.textContent;
            for (let i = 0; i < text.length; i++) {
                range.setStart(node, i);
                range.setEnd(node, i + 1);
                const top = range.getBoundingClientRect().top;
                if (lastTop !== null && top > lastTop + 1) {
                    for (let j = i - 1; j >= 0; j--) {
                        if (text[j] === ' ') {
                            breaks.push({ node, offset: j });
                            break;
                        }
                    }
                }
                lastTop = top;
            }
        } else if (node.nodeName === 'SPAN') {
            lastTop = node.getBoundingClientRect().top;
        }
    });

    breaks.reverse();
    for (const { node, offset } of breaks) {
        const afterText = node.textContent.substring(offset + 1);
        node.textContent = node.textContent.substring(0, offset + 1);
        const br = document.createElement('br');
        const afterNode = document.createTextNode(afterText);
        node.after(br, afterNode);
    }
}

function typeElement(el) {
    // visibility:hidden状態でレイアウトを計測し、改行位置に<br>を挿入
    insertLineBreaks(el);

    const chars = extractChars(el);
    const originalWidth = el.offsetWidth;
    const originalHeight = el.offsetHeight;
    el.style.minWidth = originalWidth + 'px';
    el.style.minHeight = originalHeight + 'px';
    el.textContent = '';
    el.classList.add('is-typing');

    const cursor = createCursor();
    el.appendChild(cursor);

    let i = 0;
    const type = () => {
        if (i < chars.length) {
            const char = chars[i];
            if (char.type === 'br') {
                el.insertBefore(document.createElement('br'), cursor);
            } else if (char.type === 'span') {
                const span = document.createElement('span');
                span.textContent = char.value;
                el.insertBefore(span, cursor);
            } else {
                el.insertBefore(document.createTextNode(char.value), cursor);
            }
            i++;
            setTimeout(type, 100);
        } else {
            setTimeout(() => {
                cursor.remove();
                el.style.minWidth = '';
                el.style.minHeight = '';
                el.classList.remove('is-typing');
                el.classList.add('is-typed');
            }, 1500);
        }
    };

    type();
}

export function initScrollTypingAnimation() {
    const elements = document.querySelectorAll('.jsTypingAnimate');
    if (!elements.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                typeElement(entry.target);
                observer.unobserve(entry.target);
            }
        });
    }, { threshold: 0.5 });

    elements.forEach(el => observer.observe(el));
}
